import { render, staticRenderFns } from "./welcome_template.vue?vue&type=template&id=fdc8e50a&scoped=true"
import script from "./welcome_template.vue?vue&type=script&lang=js"
export * from "./welcome_template.vue?vue&type=script&lang=js"
import style0 from "./welcome_template.vue?vue&type=style&index=0&id=fdc8e50a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc8e50a",
  null
  
)

export default component.exports